import store from './../store/store';
import Mixin from './../utils/mixin';

let Login = () => import('../pages/auth/Login');
let DirectLogin = () => import('../pages/auth/DirectLogin');
let Registration = () => import('../pages/auth/Registration');
let ForgotPassword = () => import('../pages/auth/ForgotPassword');
let NewPassword = () => import('../pages/auth/NewPassword');
let VerifyAccount = () => import('../pages/auth/VerifyAccount');

export default [
    {
        path: '/user/login',
        component: Login,
        name: 'Login',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/logout',
        name: 'Logout',
        meta: { requiresAuth: true },
        beforeEnter: async (to, from, next) => {
            const shopSlug = store.getters['auth/currentUserShopSlug'];
            await Mixin.methods.call_api('post', 'auth/logout');
            store.dispatch('cart/resetCart');
            store.dispatch('wishlist/resetWishlist');
            store.dispatch('auth/logout');
            // SPA 네비게이션 대신 완전한 페이지 새로고침으로 처리해 모든 컴포넌트 상태를 깨끗하게 초기화한다.
            next(false);
            window.location.href = shopSlug ? `/user/login?redirect=/${shopSlug}` : '/user/login';
        },
    },
    {
        path: '/user/direct_login',
        component: DirectLogin,
        name: 'DirectLogin',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/registration',
        component: Registration,
        name: 'Registration',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/forgot-password',
        component: ForgotPassword,
        name: 'ForgotPassword',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/new-password',
        component: NewPassword,
        name: 'NewPassword',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/verify-account',
        component: VerifyAccount,
        name: 'VerifyAccount',
        meta: { requiresAuth: false },
    },
];
